export function getR2PublicUrl(publicUrl: string, path: string) {
  return `${publicUrl}/${path}`
}
